import React from 'react';
import { Header } from '../../components/common/Header';
import { Footer } from '../../components/common/Footer';

export function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="bg-white rounded-lg shadow-sm p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-6">プライバシーポリシー</h1>
          
          <div className="prose prose-blue max-w-none">
            <p className="mb-4">
              株式会社クローバー（以下「当社」）は、当社が提供するサービス「Halsystem」（以下「本サービス」）における、ユーザーの個人情報の取扱いについて、以下のとおりプライバシーポリシー（以下「本ポリシー」）を定めます。
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">1. 収集する個人情報</h2>
            <p>当社は、本サービスの提供にあたり、以下の個人情報を収集することがあります。</p>
            <ul className="list-disc pl-6 my-4">
              <li>氏名</li>
              <li>メールアドレス</li>
              <li>パスワード</li>
              <li>クレジットカード情報（決済代行会社を通じて）</li>
              <li>IPアドレス、Cookie情報、利用ログ等の利用状況に関する情報</li>
              <li>その他当社が定める入力フォームにユーザーが入力する情報</li>
            </ul>

            <h2 className="text-xl font-semibold mt-8 mb-4">2. 個人情報の利用目的</h2>
            <p>当社は、収集した個人情報を、以下の目的で利用します。</p>
            <ul className="list-disc pl-6 my-4">
              <li>本サービスの提供・運営のため</li>
              <li>ユーザーからのお問い合わせに対応するため</li>
              <li>ユーザーに対して本サービスに関する情報を提供するため</li>
              <li>利用規約に違反するユーザーや、不正・不当な目的でサービスを利用しようとするユーザーの特定をし、ご利用をお断りするため</li>
              <li>ユーザーにご自身の登録情報の閲覧や変更、削除、ご利用状況の閲覧を行っていただくため</li>
              <li>有料サービスにおいて、ユーザーに利用料金を請求するため</li>
              <li>上記の利用目的に付随する目的</li>
            </ul>

            <h2 className="text-xl font-semibold mt-8 mb-4">3. 個人情報の第三者提供</h2>
            <p>当社は、次に掲げる場合を除いて、あらかじめユーザーの同意を得ることなく、第三者に個人情報を提供することはありません。ただし、個人情報保護法その他の法令で認められる場合を除きます。</p>
            <ul className="list-disc pl-6 my-4">
              <li>法令に基づく場合</li>
              <li>人の生命、身体または財産の保護のために必要がある場合であって、本人の同意を得ることが困難であるとき</li>
              <li>公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって、本人の同意を得ることが困難であるとき</li>
              <li>国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき</li>
            </ul>

            <h2 className="text-xl font-semibold mt-8 mb-4">4. 個人情報の開示</h2>
            <p>
              当社は、本人から個人情報の開示を求められたときは、本人に対し、遅滞なくこれを開示します。ただし、開示することにより次のいずれかに該当する場合は、その全部または一部を開示しないこともあり、開示しない決定をした場合には、その旨を遅滞なく通知します。
            </p>
            <ul className="list-disc pl-6 my-4">
              <li>本人または第三者の生命、身体、財産その他の権利利益を害するおそれがある場合</li>
              <li>当社の業務の適正な実施に著しい支障を及ぼすおそれがある場合</li>
              <li>その他法令に違反することとなる場合</li>
            </ul>
            <p>
              前項の定めにかかわらず、履歴情報および特性情報などの個人情報以外の情報については、原則として開示いたしません。
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">5. 個人情報の訂正および削除</h2>
            <p>
              ユーザーは、当社の保有する自己の個人情報が誤った情報である場合には、当社が定める手続きにより、当社に対して個人情報の訂正、追加または削除（以下、「訂正等」といいます。）を請求することができます。
            </p>
            <p>
              当社は、ユーザーから前項の請求を受けてその請求に応じる必要があると判断した場合には、遅滞なく、当該個人情報の訂正等を行うものとします。
            </p>
            <p>
              当社は、前項の規定に基づき訂正等を行った場合、または訂正等を行わない旨の決定をしたときは、遅滞なく、これをユーザーに通知します。
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">6. 個人情報の利用停止等</h2>
            <p>
              当社は、本人から、個人情報が、利用目的の範囲を超えて取り扱われているという理由、または不正の手段により取得されたものであるという理由により、その利用の停止または消去（以下、「利用停止等」といいます。）を求められた場合には、遅滞なく必要な調査を行います。
            </p>
            <p>
              前項の調査結果に基づき、その請求に応じる必要があると判断した場合には、遅滞なく、当該個人情報の利用停止等を行います。
            </p>
            <p>
              当社は、前項の規定に基づき利用停止等を行った場合、または利用停止等を行わない旨の決定をしたときは、遅滞なく、これをユーザーに通知します。
            </p>
            <p>
              前2項にかかわらず、利用停止等に多額の費用を有する場合その他利用停止等を行うことが困難な場合であって、ユーザーの権利利益を保護するために必要なこれに代わるべき措置をとれる場合は、この代替策を講じるものとします。
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">7. Cookieの使用について</h2>
            <p>
              当社は、ユーザーの利便性向上のため、Cookieを使用することがあります。Cookieとは、ウェブサイトがユーザーのコンピュータに送信する小さなテキストファイルで、ユーザーのコンピュータに保存されます。
            </p>
            <p>
              ユーザーは、ブラウザの設定によりCookieの受け入れを拒否することができますが、その場合、本サービスの一部機能が利用できなくなる可能性があります。
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">8. プライバシーポリシーの変更</h2>
            <p>
              本ポリシーの内容は、法令その他本ポリシーに別段の定めのある事項を除いて、ユーザーに通知することなく、変更することができるものとします。
            </p>
            <p>
              当社が別途定める場合を除いて、変更後のプライバシーポリシーは、本ウェブサイトに掲載したときから効力を生じるものとします。
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">9. お問い合わせ窓口</h2>
            <p>本ポリシーに関するお問い合わせは、下記の窓口までお願いいたします。</p>
            <p className="mt-4">
              <strong>株式会社クローバー</strong><br />
              住所：〒277-0863 千葉県柏市豊四季１６７−４１<br />
              代表者：木村 政治<br />
              メールアドレス：hal.masaharu@gmail.com<br />
              電話番号：080-5403-1349
            </p>

            <p className="mt-8 text-right">以上</p>
            <p className="text-right">制定日：2024年7月10日</p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}